import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Alert } from '@printdeal/ui-library';
import { useLocation } from '@gatsbyjs/reach-router';
import queryString from 'query-string';

const InvoiceCallbackAlerts = () => {
  const location = useLocation();
  const { authResult, changeAscriptionResult } = queryString.parse(location.search);

  // Callbacks from Buckaroo
  if (authResult) {
    switch (authResult) {
      case 'ERROR':
      case 'REFUSED':
      case 'CANCELLED':
        return (
          <Alert variant="error" isDismissible>
            {authResult === 'ERROR' && (
              <FormattedMessage id="payment.confirmation.error" defaultMessage="Oops, something went wrong processing your payment" />
            )}
            {authResult === 'REFUSED' && (
              <FormattedMessage id="payment.invoice.confirmation.authorised" defaultMessage="Paid successfully! However, it can take up to 15 minutes before it is updated in the invoice overview." />
            )}
            {authResult === 'CANCELLED' && (
              <FormattedMessage id="payment.confirmation.cancelled" defaultMessage="Payment cancelled!" />
            )}
          </Alert>
        );
      case 'AUTHORISED':
        return (
          <Alert variant="success" isDismissible>
            <FormattedMessage id="payment.invoice.confirmation.authorised" defaultMessage="Paid successfully! However, it can take up to 15 minutes before it is updated in the invoice overview." />
          </Alert>
        );
      case 'PENDING':
        return (
          <Alert variant="warning" isDismissible>
            <FormattedMessage id="payment.confirmation.pending" defaultMessage="Payment pending!" />
          </Alert>
        );
      default:
        return null;
    }
  }

  // Callbacks from Change Ascription
  if (changeAscriptionResult) {
    return (
      <Alert variant="success" isDismissible>
        <FormattedMessage id="account.invoices.list.change.ascription.success" defaultMessage="Successful Change Ascription." />
      </Alert>
    );
  }

  return null;
};

export default InvoiceCallbackAlerts;
